var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sub_footer"}},[_c('div'),_vm._m(0),_c('div',[_vm._v(" Version "+_vm._s(_vm.version)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Une solution développée par "),_c('a',{attrs:{"href":"http://iltr.fr","target":"_blank"}},[_c('img',{staticClass:"d-inline-block align-top",attrs:{"id":"logo_iltr","src":require("../../assets/img/logo-iltr.png"),"alt":"Logo ILTR"}})])])
}]

export { render, staticRenderFns }